export { Train as default } from './Train';
